import React from 'react';
import { accountActions } from 'core/Account';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import {
    Container,
    ExpandButton,
    Modal
} from 'mol-ui';
import {
    useDispatch,
    useSelector
} from 'hooks';

const RoleSelector = () => {

    const dispatch = useDispatch();
    const {
        roleSelector,
        user
    } = useSelector('account');
    const { t } = useTranslation();

    const showRoleSelector = !isEmpty(user) && !user?.role_selected || roleSelector;
    const availableRoles = user?.roles ?? [];

    const closeModal = () => {
        dispatch(accountActions.replaceAccountUser({
            role_selected: true
        }));
        dispatch(accountActions.setAccountRoleSelector(false));
    };

    const handleChangeProfile = profile => {
        dispatch(accountActions.changeProfile(profile));
    };

    return (
        <Modal active={ showRoleSelector }>
            <Container alignItems="center" gap="20px">
                <ExpandButton
                    caption={ t('Continuar como administrador') }
                    size={ 100 }
                    width={ 300 }
                    onClick={ closeModal }
                />
                {
                    availableRoles.includes('doctor') &&
                    <ExpandButton
                        danger
                        caption={ t('Ir al perfil profesional') }
                        icon="open_in_new"
                        iconPosition="right"
                        size={ 100 }
                        width={ 300 }
                        onClick={ () => handleChangeProfile('doctor') }
                    />
                }
                {
                    availableRoles.includes('patient') &&
                    <ExpandButton
                        danger
                        caption={ t('Ir al perfil paciente') }
                        icon="open_in_new"
                        iconPosition="right"
                        size={ 100 }
                        width={ 300 }
                        onClick={ () => handleChangeProfile('patient') }
                    />
                }
            </Container>
        </Modal>
    );
};

export default RoleSelector;
